module.exports = __webpack_public_path__ + "static/media/signup.0ad91987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/signup.png
// module id = 222
// module chunks = 0